import React from "react";
import { useSelector } from "react-redux";

const LocalFileBigIcon = ({ fill }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <svg
      id="add_file_ic"
      xmlns="http://www.w3.org/2000/svg"
      width="35.712"
      height="41.543"
      viewBox="0 0 35.712 41.543"
    >
      <path
        id="Path_415"
        data-name="Path 415"
        d="M28.583,15.2H21.035A5.932,5.932,0,0,0,15.1,21.135V50.808a5.932,5.932,0,0,0,5.935,5.935H44.877a5.932,5.932,0,0,0,5.935-5.935V37.637Zm5.883,23.166a4.712,4.712,0,0,1-4.789-4.633V21.5L46.387,38.366Z"
        transform="translate(-15.1 -15.2)"
        fill={fill ? fill : colors.theme}
      />
      <path
        id="Path_416"
        data-name="Path 416"
        d="M71.866,24.051H69.055v2.863a.988.988,0,0,1-.989.989h-.573a.988.988,0,0,1-.989-.989V24.051H63.589a.988.988,0,0,1-.989-.989v-.573a.988.988,0,0,1,.989-.989H66.5V18.689a.988.988,0,0,1,.989-.989h.573a.988.988,0,0,1,.989.989V21.5h2.811a.988.988,0,0,1,.989.989v.573A.988.988,0,0,1,71.866,24.051Z"
        transform="translate(-37.872 -16.399)"
        fill={fill ? fill : colors.theme}
      />
    </svg>
  );
};

export default LocalFileBigIcon;
